import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function absoluteUrl(path: string) {
  if (process.env.PRODUCTION_URL)
    return `https://${process.env.PRODUCTION_URL}${path}`;

  const origin =
    typeof window !== "undefined" && window.location.origin
      ? window.location.origin
      : "";
  if (typeof window !== "undefined") return origin + path;

  // return `https://juridice.ai${path}`
  return `http://localhost:3000${path}`;
}
